<template>
	<div class="bg-main">
    <div class="return">
      <span @click="$router.go(-1)">返回</span>
    </div>
		<div class="tzmain-page">
			<div class="tz-title">{{tongzhi.bt}}</div>
			<div class="ql-editor tz-body" v-html="tongzhi.nr"></div>
      <div v-for="item in tongzhi.attachmentList" :key="item.attachmentId" class="fjCls">
        <span @click="showFile(item.previewUrl)" style="color: #409EFF;cursor: pointer;display: inline-block;margin-right: 10px;">{{item.realName}}</span>
        <img @click="imgClk(item.attachmentId)" src="../../assets/img/xiazai.png" alt="" style="cursor: pointer;width: 20px;height: 20px;"/>
      </div>
    </div>
	</div>
</template>

<script>
	export default{
		name: "tzDetail",
		data() {
		  return {
			id: this.$route.query.id,
			tongzhi: {},
        accessToken: sessionStorage.getItem('access_token'),
		  }
		},
		mounted() {
			this.gettzDetail();
		},
		methods: {
			//获取通知公告内容,并保存已读
			gettzDetail(){
				this.$post('admin/SysTzController/newTzSaveDetail',{tzId: this.id}).then((arg) => {
					this.tongzhi = arg.result.tongzhi;
				})
			},
      showFile(filePath){
        window.open(filePath);
      },
      // 图片预览
      imgClk(id){
        window.open(`api/sys/downloadSysAttachment?access_token=${this.accessToken}&attachmentId=${id}`)
        // location.href = `sys/downloadSysAttachment?attachmentId=${id}`;
      },
		}
	}
</script>

<style lang="less">
	.bg-main{
		//min-height: 100%;
		height: calc(100% - 0px);
		//background-image: url(../../assets/img/tongzhibeijing-3.jpg);
		.tzmain-page{
			background: #fff;
			color: #333;
			/*width: 1000px;
			margin: 0 auto;
			padding: 0 30px;
			padding-top: 10px;*/
			.tz-title{
				font-size: 24px;
				font-weight: bold;
				text-align: center;
				padding: 30px 0;
			}
			.tz-body{
				font-size: 16px;
				word-wrap: break-word;
			}
		}
    .return {
      text-align: right;

      span {
        cursor: pointer;
      }
    }
	}
</style>
